<template>
  <div class="flex flex_center">
    <i v-if="isCheck" class="fa-check fa"></i>
  </div>
</template>

<script>
// enumDef
import { enumDef } from "@/common/enumDefs";
export default {
  data() {
    return {};
  },

  computed: {
    isCheck() {
      let { data, colDef } = this.params;
      let check = false;
      let trackPayStats = enumDef.trackPayStats;
      if (
		  (colDef.type === "transferredEscrow" && data.status >= trackPayStats.SentToExternal) ||
		  (colDef.type === "transferredSupplier" && data.status >= trackPayStats.Settled)
      ) {
        //
        check = true;
      }
      if (colDef.type === "transferredSupplier" && data.status >= trackPayStats.Settled) {
        //
        check = true;
      }
      return check;
    },
  },
};
</script>
<style lang="scss" scoped>
.fa-check {
  color: #58b71d;
  font-size: 20px;
}
</style>
